import { camelize } from '@ember/string';
import { filterSystemAndCurrentUser } from '../utils/messaging/user';
import { service } from '@ember/service';
import MessagingBase from './messaging-base';

export default class MessagingConversation extends MessagingBase {
  @service intl;
  @service messaging;

  async fetchInactiveReasons(conversation) {
    const baseUrl = this.buildURL('messaging-contact');
    const response = await fetch(`${baseUrl}/batch-create`, {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify({
        data: this.buildContacts(conversation),
      }),
    });

    // Conversation is no longer inactive.
    if (response.ok) {
      return [];
    }

    if (response.status !== 422) {
      throw new Error(this.intl.t('emc.general_error'));
    }

    const json = await response.json();
    const error = json.errors?.[0];
    return error?.meta ? camelizeMeta(error?.meta) : fallbackInactiveReason(error?.title);
  }

  buildContacts(conversation) {
    return filterSystemAndCurrentUser(conversation.users, this.messaging.currentProfile?.user).map(
      user => {
        return {
          type: 'contacts',
          attributes: {
            'external_id': user.externalId,
            'external_scope': user.externalScope,
            'organization_id': user.organizationId,
          },
        };
      }
    );
  }
}

function fallbackInactiveReason(title) {
  return [
    {
      message: title || 'Unknown error',
    },
  ];
}

function camelizeMeta(inactiveReasons) {
  return inactiveReasons.map(inactiveReason => {
    if (!inactiveReason.meta) return inactiveReason;

    const camelizedMeta = Object.entries(inactiveReason.meta).reduce((acc, [key, value]) => {
      return {
        ...acc,
        ...{ [camelize(key)]: value },
      };
    }, {});
    return { ...inactiveReason, meta: camelizedMeta };
  });
}
